import useDevice from "src/hooks/useDevice";

const useGatheringPublicFullBodySpacing = () => {
	const { device } = useDevice();
	const spacing = device === "desktop" ? 16 : 8;
	const halfSpacing = spacing / 2;
	const horizontalPadding = device === "desktop" ? 32 : 8;
	const containerHorizontalPadding = horizontalPadding - halfSpacing;

	return {
		spacing,
		halfSpacing,
		horizontalPadding,
		containerHorizontalPadding,
	};
};
export default useGatheringPublicFullBodySpacing;
